// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mwAGE","name":"styles_name__31Kjk","phone":"styles_phone__2Sb8u"};